import React from "react";
import capitalize from "lodash/capitalize";
import ProjectLink from "notifications/components/project_link";

const WrapupLink = ({ project, award, shouldCapitalize, wrapup }) => {
  let label = "your ";
  if (wrapup) {
    label += `$${parseInt(wrapup.award_value)} `;
  }
  label += "wrap-up";
  if (shouldCapitalize) {
    label = capitalize(label);
  }

  return (
    <ProjectLink
      project={project}
      append={`wrapup/${award}/`}
      linkTitle={label}
    />
  );
};

export default WrapupLink;
